import { useSelector } from 'react-redux';
import { useLocation } from 'react-router';

export const MapProvider = ({ render }) => {
  const location = useLocation();
  const locationPath = location.pathname.split('/mapview')[0];
  const { locationKey } = useSelector((state) => state.location);
  const { floorStatics } = useSelector((state) => state.config);
  if (!locationKey) return null;

  const locationProps = floorStatics[locationKey].paths.find(
    (pathGroup) => pathGroup.path === locationPath
  );

  const mapProps = {
    map: locationProps.img_map,
    section: floorStatics[locationKey].section,
    floor: floorStatics[locationKey].floor,
    title: locationProps.title,
    isRootFloor: location.pathname === '/',
  };

  return render(mapProps);
};
